import './UpgradeLevel.css';

const UpgradeLevel = ({ level }: { level: number }) => {
  return <div className="card-upgrade-level">{level}</div>;
};

export default UpgradeLevel;
